import { ArrowRight, ArrowDown } from "lucide-react";
import { PrimaryButton, Reveal } from "@/components/ui-bits";
import { ServiceTag, CapList } from "@/pages/services/bits";

const STEPS = [
  {
    number: "01",
    title: "UNDERSTAND",
    desc: "We understand the shipment, transportation requirements, pickup and delivery needs.",
  },
  {
    number: "02",
    title: "COORDINATE",
    desc: "We arrange appropriate transportation through a trusted carrier partner when additional capacity is required.",
  },
  {
    number: "03",
    title: "MANAGE",
    desc: "We coordinate the shipment through delivery and remain the customer's point of contact.",
  },
];

const BENEFITS = [
  "ADDITIONAL TRANSPORTATION CAPACITY",
  "FLEXIBLE EQUIPMENT OPTIONS",
  "CARRIER COORDINATION",
  "SHIPMENT MANAGEMENT",
  "SINGLE POINT OF CONTACT",
  "END-TO-END COORDINATION",
];

const Service3PL = () => {
  return (
    <section id="3pl" data-testid="service-3pl" aria-labelledby="3pl-heading" className="scroll-mt-24 bg-[#191c1e] py-16 text-white sm:py-20 lg:py-24">
      <div className="container-30">
        <Reveal className="max-w-3xl">
          <ServiceTag number="05" label="Logistics Services" dark />
          <h2 id="3pl-heading" data-testid="3pl-headline" className="mt-6 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl">
            3PL & FREIGHT BROKERAGE
          </h2>
          <p className="mt-3 font-display text-lg font-semibold text-white/85">
            Additional transportation capacity when you need it.
          </p>
          <p className="mt-5 text-base leading-relaxed text-white/65">
            When a shipment requires transportation capacity beyond what is available directly, 30 NORTH can arrange
            transportation through trusted partner carriers and manage the shipment from coordination through
            delivery.
          </p>
        </Reveal>

        <div className="mt-12 grid items-stretch gap-5 md:grid-cols-[1fr_auto_1fr_auto_1fr]" data-testid="3pl-process">
          {STEPS.map((step, i) => [
            <Reveal key={step.number} delay={i * 0.08} className="h-full">
              <div data-testid={`3pl-step-${i + 1}`} className="flex h-full flex-col border border-[#2b2f33] bg-[#121416] p-7">
                <div className="flex items-center gap-4">
                  <span className="font-display text-2xl font-extrabold text-[#ff6a00]">{step.number}</span>
                  <span className="block h-px flex-1 bg-[#2b2f33]" aria-hidden="true" />
                </div>
                <h3 className="mt-5 font-display text-lg font-bold tracking-wide text-white">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60">{step.desc}</p>
              </div>
            </Reveal>,
            i < STEPS.length - 1 ? (
              <div key={`flow-${i}`} className="flex items-center justify-center" aria-hidden="true">
                <ArrowRight className="hidden h-5 w-5 text-[#ff6a00] md:block" />
                <ArrowDown className="h-5 w-5 text-[#ff6a00] md:hidden" />
              </div>
            ) : null,
          ])}
        </div>

        <Reveal delay={0.1} className="mt-12">
          <CapList items={BENEFITS} dark testid="3pl-benefits" />
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <PrimaryButton to="/request-a-quote" testid="3pl-cta">
            REQUEST LOGISTICS SUPPORT
          </PrimaryButton>
        </Reveal>
      </div>
    </section>
  );
};

export default Service3PL;
